import { colorOptions } from '../../theme/colors.theme';
import { Icon } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

export const HelpFilledIcon = (props) => (
  <Icon boxSize="24px" viewBox="0 0 24 24" {...props}>
    <path
      d="M15.052 11.249l-.892.939c-.407.407-.689.782-.845 1.127-.22.438-.33 1.001-.33 1.69h-1.97v-.517c0-1.095.39-2.034 1.173-2.817l1.22-1.267c.407-.376.61-.845.61-1.409 0-.563-.203-1.033-.61-1.408A1.837 1.837 0 0012 6.977c-.563 0-1.049.203-1.455.61-.376.375-.564.845-.564 1.408H8.01c0-1.095.392-2.034 1.174-2.817.783-.782 1.722-1.173 2.817-1.173 1.095 0 2.034.39 2.817 1.173.782.783 1.174 1.722 1.174 2.817 0 .877-.313 1.628-.94 2.254zm-2.066 7.746h-1.972v-1.972h1.972v1.972zM12 2c-1.315 0-2.598.25-3.85.751-1.22.501-2.3 1.22-3.24 2.16a9.68 9.68 0 00-2.159 3.286A9.926 9.926 0 002 12c0 1.315.25 2.598.751 3.85a9.8 9.8 0 002.16 3.24 9.798 9.798 0 003.24 2.159c1.251.5 2.534.751 3.849.751 1.315 0 2.582-.25 3.803-.751a9.68 9.68 0 003.286-2.16 9.799 9.799 0 002.16-3.24c.5-1.251.751-2.534.751-3.849 0-1.815-.454-3.49-1.361-5.023a9.548 9.548 0 00-3.616-3.616C15.49 2.454 13.815 2 12 2z"
      fill="currentColor"
    />
  </Icon>
);

HelpFilledIcon.propTypes = {
  color: PropTypes.oneOf(colorOptions),
};
